export const NO_EXT = "Uploady - retry was not registered. Make sure you used the enhancer";